import React, { Component, Fragment } from 'react';
import moment from 'moment';

import { Filter, Main } from 'Containers/';
import { ITEM_COSTING_REPORT_FORM_NAME } from 'Common/FormEnum';
import { ItemCostingFieldEnum as Fields } from 'Common/FieldEnum';
import { withReportSubscription } from 'State/report/withReportSubscription';
import { defaultDateFormat } from 'Common/GeneralHelper';

import { ItemCostingForm } from './components/ItemCostingForm';

class ItemCostingReportContainer extends Component {
  handleSubmit = values => {
    const { getReport } = this.props;
    getReport('reports/ItemCosting', values);
  };

  getMainProps = () => {
    const { reportFetching } = this.props;
    return {
      toolbox: {
        formName: ITEM_COSTING_REPORT_FORM_NAME,
        saveButtonProps: {
          content: 'Print',
          loading: reportFetching,
        },
        shown: true,
      },
    };
  };

  render() {
    const { reportFetching } = this.props;
    return (
      <Fragment>
        <Filter title={'Item Costing Report'} />
        <Main {...this.getMainProps()}>
          <ItemCostingForm
            onSubmit={this.handleSubmit}
            initialValues={{
              [Fields.ToDate]: defaultDateFormat(moment()),
              [Fields.FromDate]: defaultDateFormat(moment()),
            }}
            loading={reportFetching}
          />
        </Main>
      </Fragment>
    );
  }
}

ItemCostingReportContainer = withReportSubscription(ItemCostingReportContainer);

export const ItemCosting = ItemCostingReportContainer;



// WEBPACK FOOTER //
// ./src/pages/itemcosting/ItemCosting.js